<script lang="ts">
	import { format } from 'svelte-i18n';
	import { onDestroy, onMount } from 'svelte';
	// Design system
	import { SidepanelContent, Text } from '@Shelly/shelly-design-system';
	//Components
	import DeviceChartsLayer from 'src/components/Chart/LayerChart/DeviceChartsLayer.svelte';
	//Helpers
	import { sidepanelChartMode } from 'src/stores/ui/sidepanel-public';
	import { isFanDevice } from 'src/helpers/interface_helpers';
	//Types
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;

	onMount(() => {
		sidepanelChartMode.set(true);
	});

	onDestroy(() => {
		sidepanelChartMode.set(false);
	});
</script>

<SidepanelContent>
	{#if isFanDevice(device?.type)}
		<Text class="mb-s" styleType="body-small">
			{$format('ventora_statistics_env_charts_help', {
				default:
					'This fan can show internal temperature and humidity history here when the cloud provides data. For charts on other hardware, use a Shelly H&T sensor or a relay with a supported temperature/humidity add-on.',
			})}
		</Text>
	{/if}
	<DeviceChartsLayer {device} />
</SidepanelContent>
